import { Link } from "react-router-dom";
import { ProductCard } from "@/components/ProductCard";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";

const ReAXOptions = () => {
  const { t } = useLanguage();
  
  const options = [
    {
      id: "touch-controllers",
      name: t('touch.controllers'),
      description: t('touch.controllers.description'),
      image: "/lovable-uploads/1c94a2db-5324-4f27-b1ce-4673b28597bb.png",
      slug: "reax-touch-controllers"
    },
    {
      id: "control-processors",
      name: t('control.processors'),
      description: t('control.processors.description'),
      image: "/lovable-uploads/63502d4f-94ae-4263-9930-af882e407a3e.png",
      slug: "reax-controllers"
    },
    {
      id: "software",
      name: t('reax.software'),
      description: t('reax.software.description'),
      image: "/lovable-uploads/1f12f184-1a1c-48ea-bf40-59ff42404b0c.png",
      slug: "reax-software"
    },
    {
      id: "accessories",
      name: t('reax.accessories'),
      description: t('reax.accessories.description'),
      image: "/lovable-uploads/2551b746-77c6-4756-8341-1b2847dc98b4.png",
      slug: "reax-accessories"
    }
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="mb-8">
        <Link
          to="/"
          className="mb-8 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t('back.to.categories')}
        </Link>
        <h1 className="mb-4 text-3xl font-bold tracking-tight">
          {t('reax.control.solutions')}
        </h1>
        <p className="text-lg text-muted-foreground">
          {t('choose.control.solution')}
        </p>
        
        {/* Features & Benefits Button for ReAX Control */}
        <div className="mt-6">
          <Link to="/features-benefits-reax">
            <Button size="lg" className="mb-8">
              ReAX Control - Features & Benefits
            </Button>
          </Link>
        </div>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
        {options.map((option) => (
          <ProductCard
            key={option.id}
            title={option.name}
            description={option.description}
            image={option.image}
            link={`/group/${option.slug}`}
            className="animate-fade-up"
          />
        ))}
      </div>
    </div>
  );
};

export default ReAXOptions;
